import { createGlobalStyle } from 'styled-components';
import tw, { GlobalStyles as BaseStyles } from 'twin.macro';

const CustomStyles = createGlobalStyle`

@font-face{
    font-display: swap;
    src:url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Regular.woff2') format('woff2'),
    url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Regular.woff') format('woff'),
    url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Regular.ttf') format('truetype');
    font-family:"ProximaNova"
}
@font-face{
    font-display: swap;
    font-weight:bold;
    font-style:normal;
    src:url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Bold.woff2') format('woff2'),url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Bold.woff') format('woff'),
    url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Bold.ttf') format('truetype');
    font-family:"ProximaNova"}
@font-face{
    font-display: swap;
    src:url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Condensed.woff2') format('woff2'),
    url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Condensed.woff') format('woff'),
    url('https://iwa-assets.fanduel.com/fd-iwa-assets/fonts/ProximaNova-Condensed.ttf') format('truetype');
    font-family:"ProximaNovaCondensed"}

body {
    font-family: "ProximaNova";
    ${tw`text-gray-dark`}
    ${tw`bg-gray-light`}
}
`;

function GlobalStyles() {
  return (
    <>
      <BaseStyles />
      <CustomStyles />
    </>
  );
}

export default GlobalStyles;
